import React, { useReducer } from 'react'
import { Paginator, PaginatorPageChangeEvent } from 'primereact/paginator'

const pgreducer = (state: any, action: any) => {
  switch (action.type) {
    case 'first':
      return { ...state, first: action.payload }
    case 'rows':
      return { ...state, rows: action.payload }
    case 'page':
      return { ...state, page: action.payload }
    case 'totalRecords':
      return { ...state, totalRecords: action.payload }
    default:
      return state
  }
}

const PaginatorCRM = React.forwardRef((props: any, ref) => {
  const { listfunction } = props
  const [pg_state, pgdispatch] = useReducer(pgreducer, {
    first: 0,
    rows: 10,
    page: 1,
    totalRecords: 0,
  })

  const handleLimitChange = (event: any) => {
    pgdispatch({ type: 'rows', payload: Number(event.target.value) })
    listfunction(pg_state.page, Number(event.target.value))
  }

  const onPageChange = (event: PaginatorPageChangeEvent) => {
    if (event.first != pg_state.first) {
      pgdispatch({ type: 'first', payload: event.first })
      pgdispatch({ type: 'page', payload: event.page + 1 })
      listfunction(event.page + 1, pg_state.rows)
    }
  }

  // Expose childFunction through the ref
  React.useImperativeHandle(ref, () => ({
    onPageChange,
    handleLimitChange,
    pg_state,
    pgdispatch,
  }))

  return (
    <>
      <div className='crm_pagination'>
        <Paginator
          template={{
            layout: 'CurrentPageReport  PrevPageLink PageLinks NextPageLink',
          }}
          currentPageReportTemplate='{first} to {last} of {totalRecords} items'
          first={pg_state.first}
          rows={pg_state.rows}
          totalRecords={pg_state.totalRecords}
          rowsPerPageOptions={[10, 20, 30]}
          onPageChange={onPageChange}
        />
      </div>
    </>
  )
})

export default PaginatorCRM
